import { forwardRef, type ComponentProps } from 'react'
import { Toaster } from 'sonner'

type Props = ComponentProps<typeof Toaster>

export const ToastProvider = forwardRef<HTMLDivElement, Props>((props, ref) => <Toaster {...props} ref={ref} />)

ToastProvider.displayName = 'ToastProvider'
